function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import storage from './storage';
import { useEffect, useMemo, useRef, useState } from 'react';
export default function useLocalStorageStateBase(key, defaultValue) {
  var defaultValueForKey = useMemo(function () {
    var isCallable = function isCallable(value) {
      return typeof value === 'function';
    };

    return isCallable(defaultValue) ? defaultValue() : defaultValue; // disabling "exhaustive-deps" because we don't want to change the default state when the
    // `defaultValue` is changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  var defaultState = useMemo(function () {
    return {
      value: storage.get(key, defaultValueForKey),
      isPersistent: function () {
        /**
         * We want to return `true` on the server. If you render a message based on
         * `isPersistent` and the server returns `false` then the message will flicker until
         * hydration is done:
         * `{!isPersistent && <span>You changes aren't being persisted.</span>}`
         */
        if (typeof window === 'undefined') {
          return true;
        }

        try {
          // - ulss = use-local-storage-state
          // - using shorthand to make library smaller in size
          localStorage.setItem('__ulss', '#');
          localStorage.removeItem('__ulss');
          return true;
        } catch (_a) {
          return false;
        }
      }()
    };
  }, [key, defaultValueForKey]);

  var _useState = useState(defaultState),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      value = _useState2$.value,
      isPersistent = _useState2$.isPersistent,
      setState = _useState2[1];

  var updateValue = useMemo(function () {
    return function (newValue) {
      var isCallable = function isCallable(value) {
        return typeof value === 'function';
      };

      if (isCallable(newValue)) {
        setState(function (state) {
          return {
            value: newValue(state.value),
            isPersistent: storage.set(key, newValue(state.value))
          };
        });
      } else {
        setState({
          value: newValue,
          isPersistent: storage.set(key, newValue)
        });
      }
    };
  }, [key]); // syncs changes across tabs and iframe's

  useEffect(function () {
    var onStorage = function onStorage(e) {
      if (e.storageArea === localStorage && e.key === key) {
        setState({
          value: storage.get(key, defaultValueForKey),
          isPersistent: true
        });
      }
    };

    window.addEventListener('storage', onStorage);
    return function () {
      return window.removeEventListener('storage', onStorage);
    };
  }, [key, defaultValueForKey]);
  var isFirstRender = useRef(true);
  useEffect(function () {
    // https://github.com/astoilkov/use-local-storage-state/issues/30
    if (isFirstRender.current && defaultState.value === undefined) {
      return;
    } // https://github.com/astoilkov/use-local-storage-state/issues/33


    if (localStorage.getItem(key) === null) {
      // set the `defaultValue` in the localStorage on initial render:
      // https://github.com/astoilkov/use-local-storage-state/issues/26
      storage.set(key, defaultState.value);
    }

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    } // update the state when the `key` property changes (not on first render because this will
    // cause a second unnecessary render)


    setState(defaultState);
  }, [key, defaultState]);
  return useMemo(function () {
    return [value, updateValue, {
      isPersistent: isPersistent,
      removeItem: function removeItem() {
        storage.remove(key);
        setState(function (state) {
          return {
            value: defaultValueForKey,
            isPersistent: state.isPersistent
          };
        });
      }
    }];
  }, [value, updateValue, isPersistent, key, defaultValueForKey]);
}